// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import Router from './routers/app'
import {Col, Row, Button, Breadcrumb, BreadcrumbItem, Dialog, Input, Tabs, TabPane, Tooltip, Loading, Alert, Select, Option, Scrollbar, CheckboxGroup, Checkbox} from 'element-ui'
import 'animate.css'
import VueResource from 'vue-resource'
import store from './stores/'

Vue.use(VueRouter)
Vue.use(VueResource)

Vue.http.options.emulateJSON = true

Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Loading)
Vue.use(Alert)
Vue.use(Select)
Vue.use(Option)
Vue.use(Scrollbar)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)

/* eslint-disable no-new */
new Vue({
  router: Router,
  store: store,
  render: h => h(App)
  // components: { firstcomponent, secondcomponent }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js